var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFillOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 2C2.6665 0.895431 3.56193 0 4.6665 0H20.0194L29.3332 9.27507V30C29.3332 31.1046 28.4377 32 27.3332 32H4.6665C3.56193 32 2.6665 31.1046 2.6665 30V2Z",
    fill: "#406EE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0103 0V8.26465C20.0103 8.81693 20.458 9.26465 21.0103 9.26465H29.3332",
    fill: "#BFD1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8823 17.4181L14.4179 13.8825L22.0199 21.4845L23.0276 24.7791C23.262 25.5453 22.5451 26.2622 21.7789 26.0278L18.4843 25.0201L10.8823 17.4181Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37361 14.9093C7.98309 14.5188 7.98309 13.8857 8.37361 13.4951L10.4949 11.3738C10.8855 10.9833 11.5186 10.9833 11.9091 11.3738L13.3459 12.8106L9.81037 16.3461L8.37361 14.9093Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75293 16.2886L13.2885 12.7531L14.467 13.9316L10.9314 17.4671L9.75293 16.2886Z",
    fill: "#D8DDEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillOut);
export default __webpack_public_path__ + "static/media/fill_out.6b9856c085a1193b09d1c64f5ba78e4d.svg";
export { ForwardRef as ReactComponent };